/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import Breadcumbs from '~/components/Breadcumbs';
import { LinhasDeCuidadoFormularioApi } from './services/linhasDeCuidadoFormularioApi';
import { LinhasDeCuidadoFormularioBuilder } from './components/linhasDeCuidadoFormularioBuilder';
import { ClipLoader } from 'react-spinners';
import { IoMdArrowBack } from 'react-icons/io';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Col, Row } from 'antd';
import history from '~/services/history';
import {
  PageTitle,
  BoxContent,
  ButtonBox,
  Content,
  BoxInput,
  TitleSection,
} from './style';
import { modalConfirm, modalSuccess } from './dados/optionsModal';
import { LinhasDeCuidadoFormularioValidation } from './validation/linhasDeCuidadoFormularioValidation';

const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
};

class LinhasDeCuidadoFormulario extends Component {
  constructor() {
    super();
    this.state = {
      items: [],
      errors: {},
      loading: true,
      saving: false,
      periodo: null,
      careLine: {},
      idRecord: null,
    };
    this.service = new LinhasDeCuidadoFormularioApi();
    this.validation = new LinhasDeCuidadoFormularioValidation();
    this.forms = React.createRef();
    this.fields = {};
  }

  async componentDidMount() {
    this.setState({ periodo: this.props.location.state.periodo });
    this.setState({
      careLine: {
        name: this.props.location.state.indicadorNome,
        systemName: this.props.location.state.indicador,
      },
    });
    this.setState({ idRecord: this.props.location.state.idRecord });

    this.setState({ loading: true });
    let p = [];
    p.push(
      this.service.obterFormularioEletronico(
        this.props.location.state.indicador
      )
    );
    if (this.props.location.state.idRecord != null)
      p.push(
        this.service.obterRegistroUpdate(
          this.props.location.state.indicador,
          this.props.location.state.idRecord
        )
      );

    Promise.all(p).then(r => {
      let items = r[0];
      let update = r.length > 1 ? r[1] : false;
      this.setState({ items: items, errors: {}, loading: false });
      this.fields = this.returnFieldsForItems(items);
      if (update) {
        //NOTE: Preenche os dados do objeto state do formulário
        this.forms.current.setStateForUpdate(update);
      }
    });

    // console.log('this.props :>> ', this.props);
  }

  returnFieldsForItems = items => {
    let fields = {};
    items
      .map(r => r.fields.map(y => y.field))
      .forEach(x => {
        x.forEach(y => {
          fields[y] = null;
        });
      });
    return fields;
  };

  save = () => {
    Swal.fire(modalConfirm).then(result => {
      if (result.value) {
        if (this.validation.validateForms(this.forms)) {
          // TODO: Ainda nao implementado
          let data = Object.assign(this.fields, this.forms.current.state);
          //IMPORTANTE: o state dos objetos quando não mostrado ele mantem mesmo que o input n esteja na tela,
          // essa solucao com a referencia do objeto consigo limpar para enviar, apenas aquilo q mostra no formulario

          for (let fieldRef in this.forms.current.fieldsRef) {
            if (
              this.forms.current.fieldsRef[fieldRef] == null ||
              this.forms.current.fieldsRef[fieldRef]?.current == null
            ) {
              data[fieldRef] = '';
            }
          }
          let response = null;
          this.setState({ saving: true });
          if (this.state.idRecord == null) {
            response = this.service.save(
              this.state.careLine?.systemName,
              this.state.periodo,
              data
            );
          } else {
            response = this.service.update(
              this.state.careLine?.systemName,
              this.state.idRecord,
              data
            );
          }
          response
            .then(r => {
              this.setState({ saving: false });
              //NOTE: Error
              if (!r.isValid) {
                if (r.errors) {
                  let err = {};
                  r.errors.forEach(r => (err[r.parameter] = r.value));
                  this.setState({ errors: err });

                  toast.error(`Favor corrigir todos os campos abaixo antes da submissão`, { autoClose: false });

                  scrollToTop();
                }
              } else {
                Swal.fire(modalSuccess).then(result => {
                  history.push({
                    pathname: `/linha-de-cuidado/${this.state.careLine.systemName}`,
                    state: {
                      periodo: this.props.location.state.periodo,
                    },
                  });

                  // window.location.reload();
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.setState({ saving: false });
            });
        }
      }
    });
  };

  //  ADICIONAR LOAD ELE E ADICIONADO QUANDO CARREGA O FORMULARIO

  render() {
    return (
      <>
        <Breadcumbs
          path="formulario-linha-de-cuidado"
          pathTitle="Adicionar Indicadores de Linhas de Cuidado"
        />
        <PageTitle>
          <div className="voltar">
            <button type="button" onClick={() => history.goBack()}>
              <IoMdArrowBack size={15} /> Voltar
            </button>
          </div>
          <span>Ficha de coleta</span>
        </PageTitle>

        {this.state.loading ? (
          <BoxContent>
            <div className="boxSpin">
              <ClipLoader
                size={50}
                color="#74a50a"
                loading={this.state.loading}
              />
            </div>
          </BoxContent>
        ) : (
          <BoxContent>
            <Content>
              <Row>
                <Col span={24}>
                  <h2 className="title">Preencha abaixo as informações:</h2>
                </Col>
                <BoxInput>
                  <Col span={12} className="item">
                    <TitleSection className="font-green">
                      > Linha de Cuidado
                    </TitleSection>
                    <input
                      type="text"
                      name="input-teste"
                      value={this.state.careLine?.name}
                      disabled
                    />
                  </Col>
                  <Col span={12} className="item">
                    <TitleSection className="font-green">
                      > Competência
                    </TitleSection>
                    <input
                      type="text"
                      name="input-teste"
                      value={this.state.periodo}
                      disabled
                    />
                  </Col>
                </BoxInput>
              </Row>
              <hr />
              {this.state.items.length > 0 && (
                <LinhasDeCuidadoFormularioBuilder
                  errors={this.state.errors}
                  items={this.state.items}
                  careLine={this.state.careLine?.systemName}
                  ref={this.forms}
                ></LinhasDeCuidadoFormularioBuilder>
              )}
              <ButtonBox>
                <button
                  type="button"
                  disabled={this.state.saving}
                  onClick={this.save}
                >
                  {this.state.saving
                    ? 'Enviando dados...'
                    : this.state.idRecord == null
                    ? 'Salvar'
                    : 'Salvar alterações'}
                </button>
              </ButtonBox>
              <br />
              <br />
              <br />
              <br />
            </Content>
          </BoxContent>
        )}
      </>
    );
  }
}

export default LinhasDeCuidadoFormulario;
